<template>
  <div>
    <div class="grid ver-padding-40">
      <h1 class="r-margin-30">Добавить пользователя</h1>
    </div>

    <div>
      <form
        @submit.prevent="onSubmit"
        @keypress.enter="pressEnter"
        class="grid"
      >
        <div class="u-16 page-block grid controls-inline">
          <!-- active -->
          <div class="r-margin-20">
            <AppCheckbox v-model="form.active" id="option-active"
              >Включен</AppCheckbox
            >
          </div>
          <!-- is_admin -->
          <div>
            <AppCheckbox v-model="form.is_admin" id="option-admin"
              >Админ</AppCheckbox
            >
          </div>
        </div>

        <div class="page-block u-16 grid cross-center between">
          <!-- email -->
          <div class="u-16 u-8-ls r-padding-0 r-padding-10-ls">
            <AppInput
              v-model="form.email"
              label="Email"
              size="medium"
              required
              @blur="validateEmail(form.email, true)"
              @input="validateEmail(form.email, false)"
            ></AppInput>
          </div>
          <!-- full_name -->
          <div
            class="u-16 u-8-ls ver-margin-20 ver-margin-0-ls l-padding-0 l-padding-10-ls"
          >
            <AppInput
              v-model="form.full_name"
              label="Полное имя"
              size="medium"
            ></AppInput>
          </div>
          <div class="u-16 ver-margin-0 ver-margin-10-ls"></div>
        </div>

        <div class="page-block u-16 grid">
          <!-- merchants -->
          <div class="u-16">
            <label>Предприятия</label>
            <el-select
              v-model="form.access_list.merchants"
              filterable
              multiple
              clearable
              placeholder
              size="large"
              @change="handleChange"
            >
              <el-option
                v-for="item in merchantList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <!-- terminals -->
          <div class="u-16">
            <label>Терминалы</label>
            <el-select
              v-model="form.access_list.terminals"
              filterable
              multiple
              clearable
              placeholder
              size="large"
            >
              <el-option
                v-for="item in sortTerminals"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <!-- processings -->
          <div class="u-16">
            <label>Процессинги</label>
            <el-select
              v-model="form.access_list.processings"
              filterable
              multiple
              clearable
              placeholder
              size="large"
            >
              <el-option
                v-for="item in sortProcessings"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <img :src="item.icon_url" alt class="processing-icon" />
                <span>{{ item.human_name }}</span>
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="page-block u-16 grid">
          <!-- rights -->
          <div class="u-16">
            <label>Права</label>
            <el-select
              v-model="form.rights"
              filterable
              multiple
              placeholder
              :disabled="form.is_admin"
              size="large"
            >
              <el-option
                v-for="item in rightsList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <!-- submit -->
        <div class="u-16 ver-margin-20">
          <AppButton class="r-margin-20" :disabled="is_disabled"
            >Добавить</AppButton
          >
          <AppButton type="border" @click.prevent="cancel">Отменить</AppButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";
import { mapGetters } from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import { _ } from "vue-underscore";
import rightsList from "@/localize/rightsList.js";
Vue.use(VueAxios, axios);

export default {
  name: "AddUser",
  data() {
    return {
      loading: false,
      form: {
        active: false,
        is_admin: false,
        email: "",
        full_name: "",
        access_list: {
          processings: [],
          merchants: [],
          terminals: []
        },
        rights: []
      },
      rightsList: [...rightsList],
      is_disabled: true
    };
  },
  methods: {
    onSubmit() {
      let email = this.form.email;
      this.form.email = email.toLowerCase();
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .post(apiUrl + "user/create", this.form, config)
        .then(({ data }) => {
          let test = data.state_id;
          if (test == 0) {
            this.$message({
              message: "Пользователь успешно добавлен",
              type: "success",
              duration: 2000
            });

            if (data.user_id) this.sendEmail(data.user_id);
            this.cancel();
          }
        })
        .catch(err => {
          if (err.response)
            this.$message({
              message: err.response.data.message,
              type: "error",
              duration: 2000
            });
        });
    },
    sendEmail(userId) {
      let host = "";
      let path = "/";
      let origin = window.location.origin;
      if (/bo-dev|localhost/.test(origin)) {
        host = "https://auth-dev.mapcard.pro";
        path = apiUrl.match(/\/(feature-.*|develop)\//)[0];
      }
      if (/bo-stage/.test(origin)) host = "https://authapi.pay2day.kz";
      if (/bo-evo/.test(origin)) host = "https://authapi.pay2day.kz";
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .post(
          host + path + "change-password",
          { email: this.form.email, reset_password: true, id: userId },
          config
        )
        .then(({ data }) => {
          if (data.state_id == 0)
            this.$message({
              message: "Письмо на сброс пароля отправлено",
              type: "success",
              duration: 2000
            });
        })
        .catch(err => {
          if (err.response)
            this.$message({
              message: err.response.data.message,
              type: "error",
              duration: 2000
            });
        });
    },
    handleChange(e) {
      this.form.access_list.terminals =
        e.length > 0 ? _.map(this.sortTerminals, "id") : [];
      this.form.access_list.processings =
        e.length > 0 ? _.map(this.sortProcessings, "id") : [];
    },
    cancel() {
      this.$router.push({
        name: "s_Users"
      });
    },
    pressEnter(e) {
      e.preventDefault();
    },
    validateEmail(email, is_shown_message) {
      if (email) {
        let re = /^[a-zа-яA-ZА-Я0-9._%+\-]+@[a-zа-яA-ZА-Я0-9.\-]+\.[a-zа-яA-ZА-Я]{2,12}$/;
        setTimeout(() => {
          if (!re.test(email.toLowerCase())) {
            if (is_shown_message)
              this.$message({
                message: "Введите корректный email",
                type: "error",
                duration: 2000
              });
            this.is_disabled = true;
            return false;
          } else {
            this.is_disabled = false;
            return true;
          }
        }, 300);
      } else {
        if (is_shown_message)
          this.$message({
            message: "Введите email",
            type: "error",
            duration: 2000
          });
        this.is_disabled = true;
        return false;
      }
    }
  },
  created() {
    if (!this.merchantList || this.merchantList.length == 0)
      this.$store.dispatch("getMerchant");
    if (!this.terminalList || this.terminalList.length == 0)
      this.$store.dispatch("getTerminal");
    if (!this.processingList && this.processingList.length == 0)
      this.$store.dispatch("getProcessing");
  },
  computed: {
    ...mapGetters(["merchantList", "terminalList", "processingList"]),
    sortTerminals() {
      let merchants = this.form.access_list.merchants;
      let terminals = this.terminalList;
      let arr = [];
      if (merchants.length > 0) {
        terminals = terminals.filter(
          el => merchants.indexOf(el.merchant_id) != -1
        );
      }
      return terminals;
    },
    sortProcessings() {
      let terminals = this.sortTerminals;
      let processings = this.processingList;
      let arr = [];
      if (terminals.length > 0) {
        processings = processings.filter(el => {
          return terminals.find(item => item.processing_id == el.id);
        });
      }
      return processings;
    }
  },
  watch: {}
};
</script>
